import React from 'react';
import { Alert, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { DragDropContext } from 'react-beautiful-dnd';
import zoneStore from '../../Store';
import { selectScreen } from '../../Store/selectionStore';
import {
  createScreen, getScreens, reorderButtons, saveZone,
} from '../../../utils/zoneMutations';
import ScreenNode from './ScreenNode';
import OrphansRow from './OrphansRow';

function NewScheme() {
  const screens = zoneStore.useState((s) => s.config.screens);

  const addScreen = async () => {
    const screen = createScreen({
      headTitle: `Экран ${screens.length + 1}`,
      type: 'btnScreen',
      isStart: screens.length === 0,
    });

    const ok = await saveZone([...getScreens(), screen], 'Экран добавлен');
    if (ok) selectScreen(screen.screenId);
  };

  // Один контекст на всю схему: вложенные DragDropContext react-beautiful-dnd не поддерживает.
  // Экран изолирован своим type у Droppable, поэтому кнопка не уедет на соседний экран.
  const onDragEnd = async (result) => {
    if (!result.destination || result.destination.index === result.source.index) return;

    const screenId = result.source.droppableId.replace('scheme-', '');

    await saveZone(
      reorderButtons(getScreens(), screenId, result.source.index, result.destination.index),
      'Порядок кнопок сохранён',
    );
  };

  const addScreenButton = (
    <Button icon={<PlusOutlined />} onClick={addScreen} style={{ margin: '12px 0' }}>
      Экран
    </Button>
  );

  const startScreen = screens.find((screen) => screen.isStart);

  if (!startScreen) {
    return (
      <DragDropContext onDragEnd={onDragEnd}>
        <div>
          <Alert
            type="warning"
            showIcon
            message="В зоне не задан стартовый экран"
            description="Откройте экран в панели справа и отметьте «Стартовый экран зоны» — без него терминал не знает, с чего начать."
          />
          {addScreenButton}
          <OrphansRow />
        </div>
      </DragDropContext>
    );
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div>
        <ScreenNode screen={startScreen} ancestors={[]} />
        {addScreenButton}
        <OrphansRow />
      </div>
    </DragDropContext>
  );
}

export default NewScheme;
